module.exports = __webpack_public_path__ + "static/media/Arrow.b3797733.svg";